import styled from 'styled-components';
export const Icons = styled.i `
  font-family: 'addi-icon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  font-size: ${({ size }) => size};
  color: ${({ color }) => color};

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &:before {
    content: '${({ name }) => `\\${name !== null && name !== void 0 ? name : ''}`}';
  }
`;
//# sourceMappingURL=icon.styled.js.map